module.exports = __webpack_public_path__ + "assets/monitor3.jpg?7295e380688c9f499c99f26aacc47f78";